import React from 'react';
import './BookTree.css';
import { range } from 'lodash';
// import { debounce } from 'lodash';
import {
  TreeInfo , //, parse_query_string,
} from './Utils';


type Props = {
  data: TreeInfo,
  is_gutenberg: boolean,
};
type State = {
  // we have expanded up to this level
  level: number,
  // we're at this offset in the previous level
  offsets: Array<number>,
};

class BookTree extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      level: 0,
      offsets: [0],
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.data !== prevProps.data) {
      const newState: State = {
        level: 0,
        offsets: [0],
      } as State;
      this.setState(newState as any)
    }
  }

  updateState(update: any) {
    this.setState(update);
    console.log('update', update);
  }

  handleStateChange(key: string, event: any) { // KeyboardEvent
    const update: any = {};
    update[key] = event.target.value;
    this.updateState(update);
  }

  showError(err: any) {
    // TODO: better
    console.error(err);
    alert(err);
  }
  render() {
    console.log('rerender');
    const tree = this.props.data.tree;

    return (
      <div style={{'height': '100%'}}>
        <div className="pane-container">
          {range(this.state.level+1).map((level) => {
            let main_offset = this.state.offsets[level];
            let summarize_range = range(1);
            if (level > 0) {
              let prev_offset = this.state.offsets[level-1];
              let prev_node = tree[level-1][prev_offset];
              if (prev_node.summarize_range === null || prev_node.summarize_range === undefined) {
                throw new Error("Clicked past leaf?")
              }
              summarize_range = range(
                prev_node.summarize_range[0], prev_node.summarize_range[1]
              )
            }
            return <div className="pane" key={level}>
              <b>
                  Depth {level}
              </b>
              <br/>
              <ul className="treechildren">
              {
                summarize_range.map((offset) => {
                  let className = 'treecontent';
                  if (offset === main_offset) {
                    className = className + ' highlight'
                  }
                  let onClick = () => {
                    let new_offsets = this.state.offsets.slice(0, level);
                    new_offsets.push(offset)
                    this.setState({
                      offsets: new_offsets,
                      level: level,
                    })
                  }
                  return <li key={offset} className={className} onClick={onClick}>
                    {tree[level][offset].summary}
                  </li>
                })
              }
              </ul>
            </div>
          })}
      {
        (() => {
          let offset = this.state.offsets[this.state.level];
          let node = tree[this.state.level][offset];
          const is_leaf = node.summarize_range === null || node.summarize_range === undefined ;
          return (
            <div className="pane">
              <b>
                Depth {this.state.level+1}
                  {is_leaf ? " (source text)" : ""}
                  {(is_leaf && this.props.is_gutenberg) ?  <a href={"https://www.gutenberg.org/policy/license.html"}>{ "  " }LICENSE</a>: ""}
              </b>
              <br/>
              {(() => {
                if (is_leaf) {
                  return (
                    <div className="treecontent" style={{fontFamily: 'verdana', fontSize: '13px'}}> {node.text} </div>
                  )
                }
                if (node.summarize_range === null) { throw Error() }
                return (
                  <ul className="treechildren">
                  {
                  range(
                    node.summarize_range[0], node.summarize_range[1]
                  ).map((child_offset) => {
                    let child_node = tree[this.state.level + 1][child_offset];
                    return <li className={"treecontent"} key={child_offset} onClick={() => {
                      let new_offsets = this.state.offsets.slice();
                      new_offsets.push(child_offset)
                      this.setState({
                        offsets: new_offsets,
                        level: this.state.level + 1,
                      })
                    }}>
                        {child_node.summary}
                    </li>
                  })
                  }
                  </ul>
                  )
                })()}
            </div>
          );
          })()
        }
        </div>
      </div>
    );
  }
}

export default BookTree;

